import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';

export default class LoginActions {
    static types = actionsFromList(['WANT_LOGIN', 'STORE_XSRF_TOKEN']);

    // sync --------------------------------------------------------------------

    static wantLogin = (want) => ({
        type: LoginActions.types.WANT_LOGIN,
        payload: { wantLogin: want },
    });

    static storeXsrfToken = (token) => ({
        type: LoginActions.types.STORE_XSRF_TOKEN,
        payload: { xsrfToken: token },
    });
}



// WEBPACK FOOTER //
// ./app/actions/login.js